// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lu-3";
export var downloadButton = "_lu-4";
export var fileContainer = "_lu-9 _lu-7";
export var fileContainerBase = "_lu-7";
export var fileContainerFixedHeight = "_lu-8 _lu-7";
export var fileInfo = "_lu-5";
export var fileInfoWidthRestricted = "_lu-6";
export var fileType = "_lu-1";
export var fileTypeName = "_lu-2";
export var image = "_lu-0";
export var link = "_lu-b";
export var overflowEllipsis = "_lu-a";